import React from 'react';

export const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-extrabold text-black mb-8">Terms of Service</h1>
        
        <div className="space-y-8 text-black">
          <section>
            <h2 className="text-2xl font-bold text-black mb-4">1. Acceptance of Terms</h2>
            <p className="mb-4">
              By accessing and using the RigidAthlete website and services, you agree to be bound by these 
              Terms of Service and all applicable laws and regulations. If you do not agree with 
              any of these terms, you are not authorized to use or access this site.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">2. License to Use</h2>
            <p className="mb-4">
              You are authorized to temporarily access and use RigidAthlete services for 
              personal and non-commercial purposes. This license does not include:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Modifying or copying our content</li>
              <li>Using the material for commercial purposes</li>
              <li>Attempting to reverse engineer our software</li>
              <li>Removing copyright or proprietary notices</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">3. User Accounts</h2>
            <p className="mb-4">
              To access certain features of our platform, you must create an account. You agree to:
            </p>
            <ul className="list-disc pl-6">
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account</li>
              <li>Accept responsibility for all activities on your account</li>
              <li>Not share your login credentials</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">4. Payment Terms</h2>
            <p className="mb-4">
              Some services may require payment. You agree to:
            </p>
            <ul className="list-disc pl-6">
              <li>Provide accurate billing information</li>
              <li>Pay all fees when due</li>
              <li>Accept our refund and cancellation policies</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">5. Disclaimer</h2>
            <p className="mb-4">
              Our services are provided "as is". We offer no warranties, express or implied, 
              and disclaim all warranties, including without limitation:
            </p>
            <ul className="list-disc pl-6">
              <li>Implied warranties of merchantability</li>
              <li>Fitness for a particular purpose</li>
              <li>Non-infringement of intellectual property</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">6. Health and Safety</h2>
            <p className="mb-4">
              You acknowledge that exercise and nutrition programs carry inherent risks. You must:
            </p>
            <ul className="list-disc pl-6">
              <li>Consult healthcare professionals before starting a program</li>
              <li>Follow safety guidelines and instructions</li>
              <li>Stop activity if you experience discomfort or pain</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">7. Limitation of Liability</h2>
            <p className="mb-4">
              RigidAthlete shall not be liable for any direct, indirect, incidental, special, or 
              consequential damages resulting from the use or inability to use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">8. Modifications to Terms</h2>
            <p className="mb-4">
              We reserve the right to modify these terms at any time. You will be notified of any 
              changes by updating the "Last updated" date of these terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">9. Contact Information</h2>
            <p>
              Questions regarding the Terms of Service should be sent to:
              <br />
              Email: legal@rigidathlete.com
              <br />
              Address: Paris, France
            </p>
          </section>

          <p className="mt-8 font-semibold">Last updated: September 24, 2025</p>
        </div>
      </div>
    </div>
  );
};
